import React from 'react';
import { TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import {  AVALOQ_ALERT_ID, BENEFICIARY_ADDRESS_ALERT_ID, DOWNTIME_STRINGS, LOCALE_TYPE, PALETTE, DASHBOARD_2FA_REGIONS } from '../../../constants';
import { Card, CardBody } from '@dbk/com.db.dbk.ui-card'
import { Info } from '@dbk/ui-icons'
import InfoBox from '@dbk/com.db.dbk.ui-info-box'

class DowntimeBanner extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getBannerAlert = (alertItems, activeAlert, isAvaloqDown) => {
    // when both Avaloq downtime alert and the beneficiary address alert is present, 
    // prioritize the Avaloq alert over the beneficiary address alert 
    const alertList = Array.isArray(alertItems) ? alertItems : [];
    const avaloqAlert = alertList.find((alertItem) => alertItem?.alertId === AVALOQ_ALERT_ID);
    const isBeneficiaryAddressAlertPresent = alertList.some(
      (alertItem) => alertItem?.alertId === BENEFICIARY_ADDRESS_ALERT_ID
    );

    return isAvaloqDown &&
      avaloqAlert &&
      isBeneficiaryAddressAlertPresent &&
      activeAlert?.alertId === BENEFICIARY_ADDRESS_ALERT_ID
      ? avaloqAlert
      : activeAlert;
  };

  convertAndFormatTime(downtimeContent, isoString, locale, replaceString){

    const date = new Date(isoString);
    const moment = require('moment-timezone');
    
    // Formatting options for the date only
    const dateOptions = {
      month: 'long',
      day: 'numeric'
    };

    // Formatting options for the time only
    const timeOptions = {
      hour: 'numeric',
      minute: '2-digit',
      hour12: locale === LOCALE_TYPE.DE_DE ? false : true,
    };

    // Format the date and time separately based on locale
    const formattedDate = new Intl.DateTimeFormat(locale, dateOptions).format(date);
    const formattedTime = new Intl.DateTimeFormat(locale, timeOptions).format(date);

    if (replaceString === DOWNTIME_STRINGS.END_DATE) {
      downtimeContent = downtimeContent?.replace(DOWNTIME_STRINGS.END_DATE, formattedDate);
      downtimeContent = downtimeContent?.replace(DOWNTIME_STRINGS.END_TIME, formattedTime);
    }
    else{
      downtimeContent = downtimeContent?.replace(replaceString, formattedDate + ", " + formattedTime + (locale === LOCALE_TYPE.DE_DE ? (" " + "Uhr") : ""));
    }
    const localTimeZone = moment.tz.guess();
    const abbreviation = moment().tz(localTimeZone).format('z');

    return downtimeContent?.replace(DOWNTIME_STRINGS.TIMEZONE, abbreviation);
  };

  onInfoClose = () => {
    this.setState({isClose: true});
    const { preLogin,  onNextActionClicked } = this.props;
    this.props.alerts.setShowAvaloqDownBanner(false);
    this.props.banner.setIsDowntime(false);
    !preLogin && onNextActionClicked();
  }

  render() {
    const { banner: { plannedDowntime, activeDowntime, downtimeData }, i18n: { messages } , auth: { isWso2Down, dashboardAuthorised},  config: { regionCode }, alerts: { isAvaloqDown, alertItems }, activeAlert, preLogin } = this.props;
    const bannerAlert = this.getBannerAlert(alertItems, activeAlert, isAvaloqDown);
    
    let displayContent = "";
      const is2FARegionCode = DASHBOARD_2FA_REGIONS.includes(regionCode);
      const twoFAAuthorised = !is2FARegionCode || (is2FARegionCode && dashboardAuthorised);
    
    if(isWso2Down){
      displayContent = messages['app.login.errorMessage.WSO2IsDown'];
    }
    else if ((activeDowntime || plannedDowntime) && !twoFAAuthorised) {
      const langCode = this.props?.languages?.destLanguageCode === LOCALE_TYPE.EN_GB ? LOCALE_TYPE.EN_US : LOCALE_TYPE.DE_DE;
      let downtimeContent = downtimeData?.alertItems[0]?.content;

      downtimeContent = this.convertAndFormatTime(downtimeContent, downtimeData?.alertItems[0]?.startTime, langCode, DOWNTIME_STRINGS.START_DATE_TIME)
      downtimeContent = this.convertAndFormatTime(downtimeContent, downtimeData?.alertItems[0]?.endTime, langCode, DOWNTIME_STRINGS.END_DATE_TIME)
      downtimeContent = this.convertAndFormatTime(downtimeContent, downtimeData?.alertItems[0]?.endTime, langCode, DOWNTIME_STRINGS.END_DATE)
      displayContent = downtimeContent;
    }else{
      displayContent = bannerAlert?.content;
    }
    return (displayContent &&
      <div className={preLogin ? 'bannerWidth' : this.props.languages.destLanguageCode === LOCALE_TYPE.DE_CH ? 'margn-top-100' : 'margn-top-60'}>
       <InfoBox
        information 
        fullWidth
        onClose={this.onInfoClose} // WMCE-51973- added for close icon
        renderMain={displayContent}/>
      </div>
        )  
  }
}

export default createContainer({
  $queries: {
    i18n:{
      messages: true
    },
    banner: {
      plannedDowntime: true,
      activeDowntime: true,
      downtimeData: true,
      setIsDowntime: { $set: 'isDowntime' }
    },
    languages: {
      destLanguageCode: true
    },
    auth: {
      isWso2Down: true,
      dashboardAuthorised: true
    },
    config: {
      regionCode: true
    },
    alerts:{
      isAvaloqDown: true,
      alertItems: true,
      setIsAvaloqDown : {$set:'isAvaloqDown' },
      setShowAvaloqDownBanner : {$set: 'showAvaloqDownBanner'}
    }
  },
})(DowntimeBanner);
